import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  timeout: 180000,
  headers: { "Content-Type": "application/json" },
});

export async function provisionalScore(idea_text) {
  const { data } = await client.post("/score/provisional", { idea_text });
  return data;
}

export async function fullScore(run_id, email) {
  const { data } = await client.post("/score/full", { run_id, email });
  return data;
}

export async function getSharedReport(share_id) {
  const { data } = await client.get(`/report/${share_id}`);
  return data;
}
